// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storyblok-nav-item{width:-moz-fit-content;width:fit-content;margin-bottom:5px}.storyblok-nav-item__icon{height:38px;margin-right:15px}.storyblok-nav-item a{color:#52575a}.storyblok-nav-item a,.white a{font-style:normal;font-weight:400;font-size:16px;line-height:22px;letter-spacing:-.01em;margin-bottom:6px;display:block}.white a{color:#fff}.uppercase a{text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
